let host = 'api.negosyonow.com'
let protocol = 'https'


module.exports = {
	protocol,
	host
}
